import type { ReactNode } from 'react';

export const symbol_bookmark_stacks: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m512-847-2 172h346q14 0 22 9.5t8 20.5q0 8-4 14.5T870-619L508-425q-14 7-28 7t-28-7L90-619q-8-5-11.5-11.5T75-645q0-8 3.5-14.5T90-671l378-202q8-4 15-4t14 4q7 4 11 11t4 15Zm-32 368 259-136H450v-180L166-645l314 166Zm-30-136Zm30 302 339-181q2-1 14-3 12 0 21 8.5t9 21.5q0 8-4 14.5T847-441L508-260q-7 4-13.5 5.5T480-253q-8 0-14.5-1.5T452-260L114-441q-8-5-12-11.5T98-467q0-13 9-21.5t21-8.5q4 0 7.5 1t6.5 3l338 180Zm0 165 339-181q2-1 14-3 12 0 21 8.5t9 21.5q0 8-4 14.5T847-276L508-95q-7 4-13.5 5.5T480-88q-8 0-14.5-1.5T452-95L114-276q-8-5-12-11.5T98-302q0-13 9-21.5t21-8.5q4 0 7.5 1t6.5 3l338 180Z"
		/>
	</svg>
);
